exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".waiting-room-sidebar--2Ya1Yv_PQiixqDK2J5CbTl {\n  display: grid;\n  grid-template-columns: auto minmax(0, 100%);\n  font-size: .75rem;\n  line-height: 1.75rem;\n  color: #000;\n  max-height: 320px;\n  overflow-y: auto;\n}\n\n.waiting-room-sidebar--2Bmg2q4dqatRvwRdBIQ2Cq {\n  color: #696b6b;\n  padding-right: .5rem;\n  text-align: right;\n}\n", ""]);

// exports
exports.locals = {
	"conferenceLogContainer": "waiting-room-sidebar--2Ya1Yv_PQiixqDK2J5CbTl",
	"conferenceLogContainer": "waiting-room-sidebar--2Ya1Yv_PQiixqDK2J5CbTl",
	"conferenceLogTime": "waiting-room-sidebar--2Bmg2q4dqatRvwRdBIQ2Cq",
	"conferenceLogTime": "waiting-room-sidebar--2Bmg2q4dqatRvwRdBIQ2Cq"
};